import { memo, useState } from "react";
import { Tabs } from "antd";
import { useSelector } from "react-redux";
import AlertIcon from "../../../Img/alert-icon.svg";
import DashboardIcon from "../../../Img/dashboard-icon.svg";
import DataAnalysisIcon from "../../../Img/data-analysis-icon.svg";
import PhaseCountWithPatientList from "./PhaseCountWithPatientList/PhaseCountWithPatientList";
import { DataAnalysis } from "../DataAnalysis";
import AlertsList from "./Alerts/AlertsList";
import Dashboard from "./Dashboard/Dashboard";

const DashboardTabsContainer = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  const { notificationList } = useSelector(({ notification }) => notification);

  const items = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: DashboardIcon,
      children: <Dashboard />,
    },
    {
      key: "alerts",
      label: "Alerts",
      icon: AlertIcon,
      children: <AlertsList />,
    },
    {
      key: "dataAnalysis",
      label: "Data Analysis",
      icon: DataAnalysisIcon,
      children: <DataAnalysis />,
    },
    {
      key: "PhaseWisePatientList",
      label: "Phase Wise Patient List",
      icon: DataAnalysisIcon,
      children: <PhaseCountWithPatientList />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      activeKey={activeTab}
      onTabClick={(key) => setActiveTab(key)}
    >
      {items.map((item) => (
        <Tabs.TabPane
          key={item.key}
          tab={
            <span>
              <img src={item.icon} alt="" style={{ marginRight: 8 }} />

              {item.label}

              {notificationList?.unreadCount
                ? item.key === "alerts" && (
                    <span class="badge bg-danger rounded-circle">
                      {notificationList?.unreadCount}
                    </span>
                  )
                : ""}
            </span>
          }
        >
          {item.children}
        </Tabs.TabPane>
      ))}
    </Tabs>
  );
};

export default memo(DashboardTabsContainer);
